export default __webpack_public_path__ + "static/icon-27-2-6ae209a73ad2b31b48d42c45a54b0a98.png";